import React from 'react';
import PhotoFrameMany from './PhotoFrameMany';
import SectionTitle from './SectionTitle';
import SectionText from './SectionText';

// the following imports contents to populate the textual components
import './Main.css';
import './FoodAndDrinks.css';
import './RestAndBars.css';

import {restAndBarsSM} from '../data/foods/restAndBarsSM';
import {restAndBarsJM} from '../data/foods/restAndBarsJM';

// Swiper add 
// the following imports images to populate the image frames (PhotoFrame and PhotoFrameMany)
import {foods} from '../data/foods/foods';
import {drinks} from '../data/foods/drinks';

// This lays out the main page, including the header (navbar), footer, and everything in between
// All contents are in terms of components, with Main as the mother of components 

function RestAndBarOfEachHotel(props) {

    // Prepare headings for bilingual 
    // set language icon, menu items and texts based on the language state from props.language
    const restAndBars = props.restAndBars;
    console.log('hotelName = ', restAndBars.name, ' restName = ', restAndBars.restaurants.name);
    console.log('Child Component = ', restAndBars);

    var mainName = '', mainText = '', restName = '', barName = '', foodsDescription = '', drinksDescription = '';
    if (props.language === 'en') {
        mainName = restAndBars.name;
        mainText = restAndBars.text;
        restName = restAndBars.restaurants.name;
        barName = restAndBars.bars.name;
        foodsDescription = restAndBars.restaurants.text;
        drinksDescription = restAndBars.bars.text;
        // console.log('LOG - ', foodsDescription);
    } else if (props.language === 'jp') {
        mainName = restAndBars.nameJ;
        mainText = restAndBars.textJ;
        restName = restAndBars.restaurants.nameJ;
        barName = restAndBars.bars.nameJ;
        foodsDescription = restAndBars.restaurants.textJ;
        drinksDescription = restAndBars.bars.textJ;
    } else if (props.language === 'ch1') {
        mainName = restAndBars.nameCh1;
        mainText = restAndBars.textCh1;
        restName = restAndBars.restaurants.nameCh1;
        barName = restAndBars.bars.nameCh1;
        foodsDescription = restAndBars.restaurants.textCh1;
        drinksDescription = restAndBars.bars.textCh1;
    } else if (props.language === 'ch2') {
        mainName = restAndBars.nameCh2;
        mainText = restAndBars.textCh2;
        restName = restAndBars.restaurants.nameCh2;
        barName = restAndBars.bars.nameCh2;
        foodsDescription = restAndBars.restaurants.textCh2;
        drinksDescription = restAndBars.bars.textCh2;
    } else {}

    /* Below renders the top roll of photos of the hotel */
    const hotelPhotoRoll = restAndBars.images.map(image => {
        const filename = image.image.split('/');
        return (
            <div key={image.id} className='hotelTopRollImage'>
                <img src={process.env.PUBLIC_URL+image.image} alt={'RestNBars -'+filename[filename.length-1]} />
            </div>
        )
    })

    // console.log('hotelPhotoRoll = ', hotelPhotoRoll);
    // const foodsContent = restAndBars.restaurants.foods.map(food => {
    const foodOrDrinkProducer = (inputs) => {

        // console.log('INPUT = ', inputs);
        const output = inputs.map(food => {
            var categoryCaption = '', categoryName = '';
            if (props.language === 'en' ) { categoryCaption = food.text; categoryName = food.name; }
            else if (props.language === 'jp' ) { categoryCaption = food.textJ; categoryName = food.nameJ; }
            else if (props.language === 'ch1' ) { categoryCaption = food.textCh1; categoryName = food.nameCh1; }
            else if (props.language === 'ch2' ) { categoryCaption = food.textCh2; categoryName = food.nameCh2; }
            else {}

            // The following renders the individual dishes 
            const foodAndDrinkItems = food.items.map(item => {
                var itemName = '', itemText = '', filename = item.image;
                if (props.language === 'en' ) { itemName = item.name; itemText = item.text; }
                else if (props.language === 'jp' ) { itemName = item.nameJ; itemText = item.textJ; }
                else if (props.language === 'ch1' ) { itemName = item.nameCh1; itemText = item.textCh1; }
                else if (props.language === 'ch2' ) { itemName = item.nameCh2; itemText = item.textCh2; }
                else {};

                return (
                    <div className='foodAndDrinkItemBox'>
                        <div className='foodAndDrinkItemImage'>
                            <img src={process.env.PUBLIC_URL+item.image} alt={'RestNBars -'+filename[filename.length-1]} />
                        </div>
                        <p className='foodAndDrinkItemText'>{itemName}</p>
                        <p className='foodAndDrinkItemText'>{itemText}</p>
                    </div>
                )
            })

            // console.log('OUTPUT 1 = ', foodAndDrinkItems);

            return (
                <div key={food.id} className='itemsSectionContainer'>
                    <div className='itemsSubsectionWords '>
                        <h4>{categoryName}</h4>
                        <p >{categoryCaption}</p> 
                    </div>
                    <div className='foodAndDrinkItemsBox'>
                        {/* <PhotoFrameMany images={food.images} caption={''} contentType={''} fontIsBlack='false'/> */}
                        {foodAndDrinkItems}
                    </div>
                </div>
            )
        })
        return (output);
    }

    const foodsContent = foodOrDrinkProducer(restAndBars.restaurants.foods);
    const drinksContent = foodOrDrinkProducer(restAndBars.bars.drinks);

    // console.log('OUTPUT = ', foodsContent);

    return (
        <div className='sectionContainer'>

            {/* This block is rendering of foods section of the page */}
                <SectionTitle ids='foods' title={mainName} />

                {/* Renders the roll of photos of the rest and bar of the hotel */}
                <div className='hotelTopRoll'>
                    {hotelPhotoRoll}
                </div>

                <div className='sectionMain'>
                    {mainText} 
                </div>

                <div className='sectionMain'>
                    {/* <br></br> */}
                    <h3>{restName}</h3>
                    {/* <br></br> */}
                    {foodsDescription} 
                </div>
                {foodsContent}

                {/* <div className='sectionEnd'>{}</div> */}

                <div className='sectionMain'>
                    {/* <br></br> */}
                    <h3>{barName}</h3>
                    {/* <br></br> */}
                    {drinksDescription} 
                </div>
                {drinksContent}
           

                {/* <div className='sectionEnd sectionMain' >{foodsContent}</div> 
                <div className='sectionEnd'>{}</div> */}
            {/* </div> */}

            {/* This block is rendering of drinks section of the page */}
            {/* <div className='drinksSection' > */}
                {/* <SectionTitle ids='drinks' title={barName} />
                <div className='sectionMain'>
                    {drinksDescription} 
                </div> */}
                {/* {drinksContent} */}
                {/* <div className='sectionEnd sectionMain' >{drinksContent}</div> 
                <div className='sectionEnd'>{}</div> */}
                <div className='sectionEnd'>{}</div>
        </div>
    )
}

// This is the main component that iterates on hotels; it is called from App section
function RestAndBars(props) {

    // scroll to the top of the page when coming from another route
    window.scroll(0,0);

    // Handle click event to select which rest and bar
    const handleRestAndBarsClick = (e) => {
        console.log('passed Value = ', e)
        const target = document.querySelector(e);
        if (target) {
            target.scrollIntoView({ behavior: "smooth" });
          }
    }

    return (
        <div>
            <div className='restAndBarsHeader'>
                {/* Header where users click to jump to the specified restaurant */}
                {/* <div className='restAndBarsHeaderClick' 
                    style={{cursor: 'pointer'}}
                    onClick={()=>handleRestAndBarsClick('#barSejour')}>{'Sejour Mint'}
                </div>
                <div className='restAndBarsHeaderClick' 
                    style={{cursor: 'pointer'}}
                    onClick={()=>handleRestAndBarsClick('#barJunior')}>{'Junior Mint'}
                </div> */}
                {/* <a href='#barSejour' onClick={(e) => e.preventDefault()}>Sejour Mint</a>
                <a href='#barJunior' onClick={(e) => e.preventDefault()}>Junior Mint</a> */}
            </div>
            <div id='barSejour' className='restAndBarsContainer'>
                <RestAndBarOfEachHotel restAndBars={restAndBarsSM} language={props.language} />
            </div>
            {/* Juniors not turned on */}
            {/* <div id='barJunior' className='restAndBarsContainer'>
                <RestAndBarOfEachHotel restAndBars={restAndBarsJM} language={props.language} />
            </div> */}
        </div>
    )
}


export {RestAndBars, RestAndBarOfEachHotel};